const Query = props => {
  const { instancesV2 } = props || {};
  const { sqlQuery } = instancesV2 || {};

  return <div>{sqlQuery}</div>;
};

export default Query;
